import styled from 'styled-components';
import { Row } from 'components/shared/Layout';
import { Link } from 'react-router-dom';
import Button from 'components/ui/Button';
import { BREAKPOINTS } from 'constants/breakpoints';

import { colours } from 'themes/default';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledHeader = styled(Row)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 75px;
  background-color: white;
  z-index: 10;
  border-bottom: solid 3px ${colours.Greyscale.MistGrey};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: relative;
  }
`;

export const StyledImage = styled.img`
  height: 26px;
  margin-left: 24px;
`;

export const StyledLink = styled(Link)`
  height: 75px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const LoyaltyAccountNumberLink = styled(Link)`
  padding-left: 5px;
  color: ${colours.Shades.BlueShade40};
  font-weight: 500;
  text-decoration: none;
`;

export const StyledButton = styled(Button)`
  margin: 4px 0;
  padding: 0 8px;
`;
